import ImageIcon from '@mui/icons-material/ImageOutlined';
import { ToggleButton, ToggleButtonProps } from '@mui/material';
import React, { FormEvent } from 'react';
import { useSlate } from 'slate-react';
import { isImageUrl } from '../../helpers';
import { insertImage } from '../../transformers';
import { notify } from "../../../../../shared/utils/notify";

// Image element insertion button
export const ImageButton = ({ value = 'image', ...props }: ToggleButtonProps) => {
	const editor = useSlate();

	const handleMouseDown = (event: FormEvent<HTMLButtonElement>) => {
		event.preventDefault();
		const url = window.prompt('Gib die URL des Bildes ein:');
		return !isImageUrl(url)
			? notify('URL ist kein Bild.')
			: insertImage(editor, url);
	};

	return (
		<ToggleButton
			size='small'
			value={value}
			selected={false}
			onMouseDown={handleMouseDown}
			{...props}
		>
			<ImageIcon />
		</ToggleButton>
	);
};
